import { useEffect, useMemo, useState } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { createLogger } from '../utils';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useMessageTestingSocket = (runIdentifier?: string): Socket | undefined => {
  const [socket, setSocket] = useState<Socket | undefined>();
  const getSocket = useGetSocket(SocketNamespace.MessageTesting);

  const logger = useMemo(() => createLogger({ namespace: SocketNamespace.MessageTesting }), []);

  useEffect(() => {
    if (runIdentifier) {
      logger.log(`Setting up socket for message-testing run: ${runIdentifier}`);
      const newSocket = getSocket();
      setSocket(newSocket);

      const handleConnect = () => {
        logger.log(`Socket connected, subscribing to: ${runIdentifier}`);
        newSocket.emit('subscribe', runIdentifier);
      };

      if (newSocket.connected) {
        handleConnect();
      } else {
        newSocket.on('connect', handleConnect);
      }

      return () => {
        logger.log(`Cleaning up socket for message-testing run: ${runIdentifier}`);
        newSocket.off('connect', handleConnect);
        newSocket.emit('unsubscribe', runIdentifier);
        newSocket.disconnect();
      };
    }
  }, [getSocket, logger, runIdentifier]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.MessageTesting);

  return socket;
};
